import { AutoCarousel } from '@components/display/emblaCarousel';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

type SplitLayoutProps = {
    slides?: { src: string; loading?: boolean }[];
    childrenProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
    useVanillaComponents?: boolean;
};

const SplitLayout = ({
    children,
    slides = [
        { src: '/static/img/backgrounds/LeftSplitImageDesktop1.png' },
        { src: '/static/img/backgrounds/LeftSplitImageDesktop2.png' },
    ],
    childrenProps,
    useVanillaComponents,
}: PropsWithChildren<SplitLayoutProps>) => {
    return (
        <div className="flex flex-col md:flex-row md:py-[23px] md:px-[21px] md:pr-12 gap-5 md:gap-10 lg:gap-[68px] h-screen md:max-w-[1865px] md:mx-auto">
            {/* Left Side */}
            <div className="flex-1 hidden w-[calc(100% - 16px)] ml-4 rounded-lg overflow-hidden md:block">
                <AutoCarousel slides={slides} useVanillaComponents={useVanillaComponents} />
            </div>
            {/* Right Side */}
            <div
                {...childrenProps}
                className={clsx(
                    'flex flex-col flex-1 py-[40px] md:py-0 px-[21px] md:pr-0 md:px-0',
                    childrenProps?.className
                )}
            >
                {children}
            </div>
        </div>
    );
};

export { SplitLayout };
